import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { readLocalStorage, readLocalStorageJson, writeLocalStorage } from 'app/core/utils/platform.util';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  /**
   * Constructor
   */
  constructor(
  ) {
  }

  /**
   * Intercept
   *
   * @param req
   * @param next
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Clone the request object
    let newReq = req.clone();
    let currentUser
    let token
    currentUser = readLocalStorageJson<{ token?: string }>("currentUser");
    if (currentUser?.token) {
      token = currentUser.token;
    }
    if (token) {
      if (!req.url.includes('assets/i18n/') && !req.url.includes('/i18n/')) {
        newReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${currentUser.token}`,
            Accept: "application/json",
          },
        });
      } else if (req.url.includes("undefined") || req.url.includes("null")) {
        writeLocalStorage("language", "en")
        newReq = req.clone({
          url: req.url.replace(/undefined|null/, "en")
        })
      }
    }

    // Response
    return next.handle(newReq);
  }
}
